var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 39.8 36.86",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,1.52v-1c10-2.09,16.73,2.1,20.59,10.93C26.86,8.69,27.61-.89,37,.81L24,16,39.8,35.27v1c-10.87,2.63-17-3.7-21.69-12.68-3,3.38-5.23,6-7.53,8.56-4.11,4.59-4.12,4.58-8.95,3.29L15.2,19.78ZM30.33,33l1.43-1.36C25.2,23,18.68,14.28,12,5.69c-.74-1-2.31-1.28-3.49-1.89L7.79,5C15.58,14.08,21.83,24.49,30.33,33Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b711bd5daf9fe878a8fe38d07c46ec15.svg";
export { ForwardRef as ReactComponent };